import { useSelector } from 'react-redux';

import { RootState } from '../redux/rootReducer';

const useAllSheetTreeIdsByBook = (bookId: string | undefined): string[] => {
  const sheetTreeDb = useSelector((state: RootState) => state.sheetTreeDb);
  const ids = Object.keys(sheetTreeDb.sheetTrees).filter(id => sheetTreeDb.sheetTrees[id].bookId === bookId);

  return ids;
}

export default useAllSheetTreeIdsByBook;
